import { Button, Divider, Header, Text } from '@wework/dieter-ui'
import { withFloorMap, withManager } from '@wework/react-floormap'
import _ from 'lodash'
import compose from '../../utils/compose'
import React, { useEffect, useState } from 'react'
import Row from '../Common/Row'
import { withSnackbar } from '../../hoc/SnackBarProvider'
import { useSidebar } from '../../hoc/withSidebar'
import CloseIcon from '../../assets/images/CloseIcon.svg'
import notLinkedIcon from '../../assets/icons/notLinkedIcon.png'
import IMTheme from '../../style/IMTheme'
import { Loader } from 'semantic-ui-react'

function BuildingInfoProducts({ floorMap, manager, snackBars }) {
  const { openSideBar, closeSideBar } = useSidebar()
  const { currentBuilding, currentFloor } = floorMap
  const floorName = _.get(currentFloor, 'name')
  const [data, setData] = useState<any>([])
  const handleClickOnNotLinked = () => openSideBar('BuildingInfoNotLinked')
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    const fetchUnlinkedProducts = async () => {
      try {
        const client = manager.getClient()
        const response = await client.get(`/floors/${currentFloor?.uuid}`, {
          'extra_fields[floor]': 'inventory_count_split',
        })
        const { data, meta } = response
        if (!meta.success) {
          throw new Error(meta.message)
        }
        setLoading(false)
        setData(data.attributes.inventory_count_split)
      } catch (error) {
        setLoading(false)
        snackBars.addAlert({
          text: `There was a problem getting info, ${error}`,
          variant: 'error',
        })
      }
    }
    fetchUnlinkedProducts()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manager])

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Row>
          <Header as="h3" style={{ margin: 0 }}>
            Products
          </Header>
          <Button
            basic
            onClick={() => closeSideBar()}
            icon={
              <div style={{ width: 18, height: 18 }}>
                <CloseIcon />
              </div>
            }
            style={{
              margin: 0,
            }}
          />
        </Row>
        <Text style={{ marginTop: 28 }} size="huge">
          {floorName}
        </Text>
        <Divider light style={{ margin: '24px 0px 0px 0px' }} />
        {loading ? (
          <div
            style={{
              height: 150,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Loader active style={{ position: 'fixed' }} size="small" />
            <span style={{ marginTop: 12 }}>Loading...</span>
          </div>
        ) : (
          <>
            {data &&
              data.length > 0 &&
              data.map(({ type, unlinked, linked }) => (
                <div key={type}>
                  <Row style={{ marginTop: 20 }} justify="flex-start">
                    <Text style={{ textTransform: 'capitalize' }} size="small">
                      {`${unlinked.length} ${type.toLowerCase()}`}
                    </Text>
                  </Row>
                  {unlinked && unlinked.length > 0 && (
                    <Row style={{ margin: 0 }} justify="flex-start">
                      <Text
                        primary
                        style={{
                          cursor: 'pointer',
                          fontSize: IMTheme.fontSizes[1],
                        }}
                        onClick={handleClickOnNotLinked}
                      >
                        {`${unlinked.length} not linked`}
                      </Text>
                      <img
                        src={notLinkedIcon}
                        style={{ width: 12, height: 12, marginLeft: 2 }}
                        alt=""
                      />
                    </Row>
                  )}
                </div>
              ))}
          </>
        )}
      </div>
    </>
  )
}

export default compose(
  withFloorMap(),
  withManager()
)(withSnackbar(BuildingInfoProducts))
